export var FilterActionType;
(function (FilterActionType) {
    FilterActionType["SET_SELECTED_VALUE"] = "setSelectedValue";
    FilterActionType["CALL_ACTION"] = "callAction";
})(FilterActionType || (FilterActionType = {}));
//# sourceMappingURL=FilterActionType.js.map